import {Iso8601, KpiRangeBreachSeverity} from '@hconnect/common/types'

export enum SlaTargetType {
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  Range = 'range'
}

export type KpiTabValuesDto = {
  tabType: TabTypeDto
  kpiGroups: KpiGroupDto[] | null
  kpiDefinitions: KpiDefinitionDto[]
}

export type KpiGroupDto = {
  id: string
  name: string
}

export type KpiDefinitionDto = {
  id: string
  name: string
  plantId: string
  year: number
  tabType: TabTypeDto
  slaTarget: SlaTargetDto
  kpiValues: KpiValueDto[]
  kpiGroupId?: string | null
  cceKpiDefinitionId?: number | null
}

export type KpiValueDto = {
  id: string
  month: number
  value: number | undefined
  breachSeverity?: KpiRangeBreachSeverity
  version: number
  hasComments: boolean
}

export type SlaTargetDto = {
  unit: string
  targetType: SlaTargetType
  targetValue: number | null
  minValue: number | null
  maxValue: number | null
}

export type SlaTableDataGroupRow = {
  id: string | number
  type: 'group'
  year: number
  subItems: SlaTableDataRow[]
  dataField: string | undefined
}

export type SlaTableDataItemRow = {
  id: string | number
  type: 'item'
  year: number
  subItems: SlaTableDataRow[]
  dataField: string | undefined
  unit?: string
  target?: string
  kpiValues: KpiValueDto[]
  cceKpiDefinitionId?: number | null
}

export type SlaTableDataRow = SlaTableDataGroupRow | SlaTableDataItemRow

export enum TabTypeDto {
  ProcessEngineer = 'processEngineer',
  QualityEngineer = 'qualityEngineer',
  ReliabilityEngineer = 'reliabilityEngineer',
  SystemsEngineer = 'systemsEngineer',
  OutagePlanning = 'outagePlanning',
  OptimizationSpecialist = 'optimizationSpecialist'
}

export interface UpdateKpiValueDto {
  id: string // UUID of the KPI Value
  value: number | null
  version: number // Version of the KPI Value
}

export interface UpdateKpiValuesDto {
  kpiValues: UpdateKpiValueDto[]
}

export interface UpdateResultDto {
  isSuccess: boolean
  updatedCount: number
}

export type KpiValuesById = Record<string, number | undefined>
export type KpiValueVersionsById = Record<string, number>

export enum KpiValueEventType {
  Version = 'version',
  Comment = 'comment'
}

type KpiValueEventBase = {
  id: string
  eventDate: Iso8601
  userId?: string | null
  userName?: string | null
}

type KpiValueEventVersion = KpiValueEventBase & {
  eventType: KpiValueEventType.Version
  value: string
  version: number
}

type KpiValueEventComment = KpiValueEventBase & {
  eventType: KpiValueEventType.Comment
  value: string
}

export type KpiValueEventDto = KpiValueEventVersion | KpiValueEventComment

export type CreatedCommentDto = {id: string}

export type SlaKpiCommentDefinitionDto = {
  id?: string
  name: string
  year: number
  tabType: TabTypeDto
  target?: SlaTargetDto
}

export type SlaKpiCommentValueDto = {
  id: string
  month: number
  value: number | null
}

export type SlaKpiCommentsByMonthDto = {
  definition: SlaKpiCommentDefinitionDto
  value: SlaKpiCommentValueDto
  commentText: string
  timestamp: Iso8601
  userName?: string | null
}

export enum SlaTrackingQueryKey {
  SlaKpiTabValues = 'sla-tracking-kpi-tab-values',
  SlaKpiTabValueEvents = 'sla-tracking-kpi-tab-value-events',
  SlaKpiComments = 'sla-tracking-kpi-comments'
}
